import {
  Box,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import Textfield from "../../shared/textfield";
import dayjs from "dayjs";
import { pcolor, textFieldTitle } from "../../../style2";

export default function SchoolInformation(props) {

  const [disabledField, setDisabledField] = useState(true);
  const [SEN_EHCP, setSEN_EHCP] = useState("SEN");
  //const ls = new AccessLocalStorage();
  const handleEdit = () => {
    setDisabledField(!disabledField);
    if (!disabledField) {
      // To save changes here
    }
  };

  const handleCancelEdit = () => {
    setDisabledField(true);
  };

  const handleSEN_EHCP = (event) => {
    setSEN_EHCP(event.target.value);
  };

  const profile = props.profile;

  return (
    <Box ml={2} mr={2} mb={2}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Textfield title='School or Nursery name'
            value={profile.childEducation?.schoolName}
            disabled={disabledField} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Textfield title='Class/Year'
            value={profile.childEducation?.class}
            disabled={disabledField} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Textfield
            title='Name of School/Nursery Nurse'
            value={profile.childEducation?.schoolNurseName}
            disabled={disabledField}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Textfield
            title='Name of the Class teacher'
            value={profile.childEducation?.teacherName}
            disabled={disabledField}
          />
        </Grid>
        {profile.childEducation?.teachingAssistantName && profile.childEducation?.teachingAssistantName !== "" ? <Grid item xs={12} sm={6}>
          <Textfield
            title='Name of the Teaching assistant'
            value={profile.childEducation?.teachingAssistantName}
            disabled={disabledField}
          />
        </Grid> : null}

        {profile.childEducation?.specificProblems && profile.childEducation?.specificProblems !== "" ? <Grid item xs={12}>
          <Textfield
            title='Specific problems'
            value={profile.childEducation?.specificProblems}
            disabled={disabledField}
            multiline
            rows={2}
          />
        </Grid> : null}
      </Grid>
      <Box m={2} />
      <Divider />
      <Box m={2} />
      <Grid container>
        <Grid item xs={12} sm={6}>
          <FormControl>
            <FormLabel sx={{ color: pcolor }}>SEN/EHCP</FormLabel>
            <RadioGroup row value={profile.childEducation?.specialEducationPlan} onChange={handleSEN_EHCP}>
              <FormControlLabel
                value={1}
                control={<Radio />}
                label='SEN'
                disabled={disabledField}
              />
              <FormControlLabel
                value={2}
                control={<Radio />}
                label='EHCP'
                disabled={disabledField}
              />
            </RadioGroup></FormControl>
        </Grid>
        {profile.childEducation?.specialEducationPlan === 2 && profile.childEducation?.ehcpDate !== null && profile.childEducation?.ehcpDate != "" ?
          <Grid item xs={12} sm={6}>
            <Typography sx={textFieldTitle}>
              EHCP Issue/Review Date
            </Typography>
            <Box m={1} />
            <Textfield
              value={profile.childEducation?.ehcpDate !== null && profile.childEducation?.ehcpDate != "" ? dayjs(profile.childEducation?.ehcpDate).format("DD/MM/YYYY") : ""}
              disabled={disabledField}
            />
          </Grid>
          : null}
      </Grid>
    </Box>
  );
}
